// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Logs_establishments__1MxSb","header":"Logs_header__2Lqp0","tableHeader":"Logs_tableHeader__HUPNL"};